import { Control, RegisterOptions, useController } from "react-hook-form";
import { TextInput as CustomTextInput, TextInputProps as CustomTextInputProps } from "../../../components";
import { FormData } from "../formData";

type StringField = { [K in keyof FormData as FormData[K] extends string ? K : never]: FormData[K] };

export interface TextInputProps extends Omit<CustomTextInputProps, "theme"> {
  name: keyof StringField;
  control: Control<FormData>;
  rules?: RegisterOptions;
}

export default function TextInput({ name, control, rules, ...props }: TextInputProps) {
  const {
    field: { onChange: onChangeText, ref, ...field },
    fieldState: { error },
  } = useController({ control, name, rules });

  return (
    <CustomTextInput
      testID={name}
      blurOnSubmit={false}
      returnKeyType="next"
      {...{ ...props, ...field, ...{ ref, error, onChangeText } }}
    />
  );
}
